import {assetIsPresent} from '@netx/core-asset-next/enablers/assetIsPresent';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import type {IAsset} from '../schema';

export const canResyncAsset = (asset?: IAsset) => {
	if (!asset) return false;
	if (!assetIsPresent(asset)) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.RESYNC,
	});
};
